import { NgModule } from '@angular/core';
import { AuthCallbackComponent } from '@app/auth/auth-callback.component';
import { RouterModule, Routes } from '@angular/router';
import { LoggedOutComponent } from '@app/auth/logged-out.component';
import { ImpersonateComponent } from '@app/auth/impersonate.component';
import { EndImpersonationComponent } from '@app/auth/end-impersonation.component';

const routes: Routes = [
  {
    path: 'callback',
    component: AuthCallbackComponent,
  },
];

@NgModule({
  declarations: [
    AuthCallbackComponent,
    LoggedOutComponent,
    ImpersonateComponent,
    EndImpersonationComponent,
  ],
  imports: [RouterModule.forChild(routes)],
})
export class AuthModule {}
